import React from "react";
import { Outlet } from "react-router-dom";

export const LayoutHome = () => {
	return (
		<div className="fixed inset-0 h-full">
			{/* <p>Layout Home</p> */}
			<Outlet />
		</div>
	);
};
